import ProcessingNodeBase from '~/models/journey/ProcessingNodeBase'
import { SessionStore } from '~/stores/session'
import dayjs from 'dayjs'

export default class SetNextPlanYearNode extends ProcessingNodeBase {
  async run(): Promise<void> {
    const session = SessionStore.use()

    session.planYear = dayjs().year() + 1
  }
}
